export default {
  "Record already exists": "Record already exists",
  "User already exists with email or mobile": 'User already exists with email or mobile',
  stateRequired: "State is required.",
  maxLimit:'Max limit must not be greater that six digit.',
  emptyDeforestationStatus: "EUDR deforestation status is empty.",
  deleteFarmH: "Are you sure you want to delete this farm?",
  deleteFarmMsg:
    "Please provide further confirmation as deleting this farm will delete all the farm related data such as crops, reports etc",
  selectFileToUpload: "Select file to upload data",
  totalRecords: "Total Records",
  success: "Success",
  used: "Used",
  recordsImported: "Records imported",
  psw: "Password",
  topFive: "Top 5",
  deleted: "Deleted Successfully",
  failed: "Failed",
  fermentation: "Fermentation",
  confPsw: "Confirm Password",
  newPsw: "New Password",
  email: "Email",
  emailId: "Email ID",
  submit: "Submit",
  cancel: "Cancel",
  faqs: "FAQ",
  id: "ID",
  read: "Read",
  unread: "Unread",
  addFarm: "Add Farm",
  reset: "Reset",
  processor: "Processor",
  cuppingScore: "Cupping Score",
  label: "Label",
  expiry: "Expiry",
  users: "Users",
  language: "Language",
  appUser: "App User",
  app_users: "App Users",
  offline_users: "Offline Users",
  dimitraAdmin: "Dimitra Admin",
  admin_users: "Admin Users",
  search: "Search",
  searchByProducerName: "Search by Producer Name",
  searchBy: "Search {type}",
  firstName: "First Name",
  lastName: "Last Name",
  mobile: "Mobile",
  mobileNumber: "Mobile Number",
  phoneNumber: "Phone Number",
  department: "Department",
  departmentName: "Department Name",
  role: "Role",
  status: "Status",
  "Due Diligence Reports": "Due Diligence Reports",
  "EUDR Deforestation Assessments": "EUDR Deforestation assessments",
  "Risk Assessments": "Risk Assessments",
  Used: "Used",
  permission: "Permissions",
  activity_log: "Activity Log",
  profile_auth: "Profile Authentication",
  countryCode: "Country Code",
  selectDept: "Select Department",
  selectRole: "Select Role",
  edit: "Edit",
  update: "Update",
  delete: "Delete",
  view: "View",
  VIEW: "View",
  deactivate: "Deactivate",
  activate: "Activate",
  serverError: "Something went wrong. Please try after sometime.",
  minute: "Minute",
  perHour: "Per hour",
  day: "Day",
  enterDescription: "Enter your description here",
  enterHere: "Enter Here",
  enterMobile: "Enter mobile number",
  phoneRequired: "Phone is required",
  phoneValid: "Phone must be valid",
  unableToUpdate: "Unable to update",
  membershipPlans: "Membership Plans",
  keysAvailable: "Keys Available",
  pressImportToProceed: "Press Import to proceed",
  downloadTheSampleCsvandExcelFileToFollowTheStructure: "Download the sample .csv or .xlsx or .xls file to follow the structure",
  pleaseUploadTheUserDataFile: "Please Upload the user data file.",
  remainingQuota: "Remaining Quota",
  downloadTemplate: "Download Template",
  dragAndDropOrBrowseYourFile: "Drag and drop or browse your file.",
  fileUploadedSuccessfully: "File Uploaded Successfully",
  byWeek: "By Week",
  byMonth: "By Month",
  byYear: "By Year",
  custom: "Custom",
  name: "Name",
  warehouse: "Warehouse",
  regionState: "Region/State",
  hour: "Hours",
  days: "Days",
  minutes: "Minutes",
  provinceState: "Province/State",
  cityTown: "Village/City/Town",
  membershipValidity: "Base Membership Validity",
  basicPlanValidity: "Basic Plan Validiity",
  membershipExpiryDate: "Membership Expiry Date",
  extendedValidity: "Extended Validity",
  exportAsCSV: "Export as CSV",
  filterBy: "Filter By",
  clearAllFilters: "Clear All Filters",
  autoCondition: "Auto Conditions",
  conditional: "Conditional",
  comingSoon: "Coming Soon",
  userRole: "User Role",
  addUserRole: "Add User Role",
  editUserRole: "Edit User Role",
  additionalInformationRequired: "Additional Information Required",
  back: "Back",
  browse: "Browse",
  clearAll: "CLEAR ALL",
  filterByRegion: "Filter By Region",
  continue: "Continue",
  resolveNow: "Resolve Now",
  description: "Description",
  selectWeek: "Select Week",
  hideSplash: "Hide Splash ?",
  hideLogo: "Hide Logo ?",
  confirm: "CONFIRM",
  selectMonth: "Select Month",
  selectDateRange: "Select Date Range",
  regionDistrict: "Region/District",
  address: "Address",
  familyTribe: "Family Tribe",
  website: "Website",
  deactivated: "Deactivated",
  active: "Active",
  inactive: "inactive",
  "Download Survey List": "Download Survey List",
  scheduled: "Scheduled",
  country: "Country",
  state: "State",
  farmer: "Farmer",
  commodity: "Commodity",
  quantity: "Quantity",
  unit: "Unit",
  price: "Price",
  save: "SAVE",
  remove: "Remove",
  stateIsReq: "State is required",
  cityIsReq: "City is required",
  addressIsReq: "Address is required",
  membershipTypeReq: "Membership type is required",
  extendedReasonReq: "Extend reason is required",
  numberOfDaysReq: "Number of days is required",
  extendedMembershipValidity: "Extended Membership Validity",
  set: "SET",
  adminRole: "Admin Role",
  typeMsg: "Type your message here",
  manageFarmer: "Manage Farmer",
  manageOfflineFarmers: "Manage Offline Farmers",
  dashboardSettings: "Dashboard Setting",
  weightUnit: "Weight Unit",
  done: "Done",
  noRecordFound: "No record found",
  farmerName: "Farmer Name",
  production: "Production",
  registered: "Registered",
  downloadForReport: "DOWNLOAD PDF REPORT",
  downloadPdfReport: "Download PDF Report",
  download: "DOWNLOAD",
  notifications: "Notifications",
  markAllAsRead: "Mark All As Read",
  viewNotifications: "View Notifications",
  youAreUpToDate: "You are up to date",
  sendNotifications: "Sent Notifications",
  createNotification: "Create Notification",
  viewAllNotifications: "View All Notifications",
  createNotificationForGroup: "Create Notification for the Group/Multiple Users",
  createNotificationForDimitra: "Create Notification for the Dimitra Admin",
  note: "*Note: Only Mp4 file is supported for video",
  validMemberships: "Valid Memberships",
  memberShipPlanMessage:
    "Are you sure you want to delete this membership plan?",
  deleteMemberShipPlan: "Delete Membership Plan",
  systemAutoLogout: "System will auto Logout in 2 min",
  monday: "Monday",
  tuesday: "Tuesday",
  Wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  warning: "Warning",
  addnewOfflineFarmer: "Add new offline farmer",
  export: "Export",
  exportAs: "Export As",
  createNewOfflineFarmer: "Create New Offline Farmer",
  offlineFarmerForByingStationOnly:
    "Offline Farmer for buying station only (Local)",
  offlineFarmerForAllByingStations:
    "Offline farmer for  all buying stations (Global)",
  noDataAvailable: "No Data Available",
  buyingStation: "Buying Station",
  dryMillingStation: "Dry Milling Station",
  mergeWithExistingAccount: "Merge with an existing account",
  createNewAccount: "Create new account",
  mobileOrEmailRequiredForRegister:
    "To register the app, at least one detail must be provided either mobile number or email.",
  selectLanguage: "Select language",
  basicPlan: "Basic Plan",
  local: "Local",
  newUser: "New User",
  merged: "Merged",
  global: "Global",
  qrcode: "QR Code",
  goBack: "Back",
  profile: "Profile",
  pleaseChooseAnImageFile: "Please choose an image file",
  fileIsTooBigSelectUnder1MB:
    "Your file is too big! Please select an image under 1MB",
  pleaseTryAgainAfterSometime: "Please try after sometime",
  somethingWentWrong: "something went wrong.",
  passwordChangedSuccesFully: "Password changed successfully",
  passwordDoesNotMatch: "Passwords do not match",
  copyToCliped: "Copied to clipboard",
  profileUpdated: "Profile data updated.",
  emailAndMobileCantbeEmpty: "Email and Mobile, both can't be empty.",
  changePassword: "Change Password",
  generateSecurePassword: "Generate Secure Password",
  restoreDefault: "Restore Default",
  customization: "Customization",
  recordsPerPage: "Records per Page",
  Honey: "Honey",
  "Natural (Dry)": "Natuurlijk (Droog)",
  Wine: "Wijn",
  "Semi-Washed": "Half Gewassen",
  "Full-Washed": "Volledig Gewassen",
  lessThanOneMonth: "Less Then 1 Month",
  oneTo8Month: "1-8 Months",
  sixTo12Month: "6-12 Months",
  moreThanYear: "More Than 1 Year",
  meter: "Meter",
  kiloMeter: "Kilometer",
  mile: "Mile",
  gram: "Gram",
  kilogram: "Kilogram",
  pound: "Pound",
  cubicKilo: "Cubic Kilometer (km³)",
  cubicMeter: "Cubic Meter (m³)",
  cubicCentimeter: "Cubic Centimeter (cm³)",
  cubicMilimeter: "Cubic Milimiter (mm³)",
  showingAll: "Showing All",
  emailSentSuccessfully: "Email sent successfully",
  step: "Step",
  fileError: "File Error",
  ProvideFileFormat: "Important Note: Please Provide following format (PNG/JPEG)",
  signHere: "Sign Here",
  numOfDaysRemaining: "Number of Days Remaining",
  requesterNameIsRequired: "Requester Name is required",
  messageIsRequired: "Message is required",
  emailIsInvalid: "Email is invalid",
  emailIsRequired: "Email is required",
  all: "All",
  filesSucessfullyUploaded:"Files successfully uploaded.",

  unsynced_record: "Unsynced Record",
  loadingData: "Loading Data...",
  markAsRead: "Mark As Read",

  of: "of",
  ok: "OK",

  orderBy: "Order By",
  select: "Select",
  type: "Type",
  uploadImageVideo: "Upload Images",
  user: "User",
  userName: "User Name",
  usersSelected: "Users Selected",
  topics: "Topics",
  date: "Date",
  addNew: "ADD NEW",
  exportAsCsv: "Export as CSV",
  noData: "No Data Found",

  dashboard: "Dashboard",
  mainDashboard: "Main Dashboard",
  userDashboard: "User Dashboard",
  areYouSureText: "Are you sure you want to take this action.",


  cropsReport: "Crops Report",
  today: "Today",
  week: "Week",
  month: "Month",
  year: "Year",
  cropsStatistics: "Crops Statistics",
  crops: "Crops",
  acres: "Acres",
  totalPlantedArea: "Total Planted Area",
  farmersChart: "Farmers Chart",
  cropsName: "Crops Name",
  farmers: "Farmers",
  farms: "Farms",
  planted: "Planted",
  plantedArea: "Planted Area",
  harvested: "Harvested",
  yieldAcre: "Yield/Acre",
  selectCrop: "Select Crop",
  listByYield: "List by Yield",
  listByPlantedArea: "List by Planted Area",
  equipmentReport: "Equipment Report",
  equipmentChart: "Equipment Chart",
  selectFarmer: "Select Farmer",
  selectFarmers: "Select Farmers",
  equipmentName: "Equipment Name",
  region: "Region",
  counts: "Counts",
  large: "Large",
  medium: "Medium",
  small: "Small",
  listByFarmer: "List By Farmer",
  rowsPerPage: "Rows per page",
  farmersReport: "Farmers Report",
  farmsReport: "Farms Report",
  farmersStatistics: "Farmers Statistics",
  farmStatistics: "Farm Statistics",
  averageFarmerLand: "Average Farmer Land",
  totalFarmerLand: "Total Farmer Land",
  largeFarmers: "Large Farmers",
  mediumFarmers: "Medium Farmers",
  smallFarmers: "Small Farmers",
  listByLand: "List by Land",
  listByFarm: "List by Farm",
  AvgLandAcre: "Avg. Land/Acre",
  listbyCrop: "List by Crop",
  listbyZone: "List by Zone",
  farmName: "Farm Name",
  zones: "Zones",
  area: "Area",
  goalsAchievedReport: "Goals Achieved Report",
  listByCrops: "List By Crops",
  goalsAchievedChart: "Goals Achieved Chart",
  goalsAchieved: "Goals Achieved",
  goalsFailed: "Goals Failed",
  successRate: "Success Rate",
  achieved: "Achieved",
  equipment: "Equipment",
  pests: "Pests",
  regions: "Regions",
  filterByCrops: "Filter By Crops",
  searchCrops: "Search Crops",
  batchCode: "Batch Code",
  batchRating: "Batch Rating",
  MakeASelection: "Make a selection",
  typeTotalCoffeeQuantity: "Type total coffee quantity",
  typeHumidity: "Type humidity",
  valueInPercent: "value in %",
  purchaseOrderRequired: "Purchase Order is required",
  totalCoffeeCherryRequired: "Total Coffee Cherry is required",
  processTypeRequired: "Process Type is required",
  fermentationTypeRequired: "Fermentation Type is required",
  stationInfo: "Station Info",
  purchaseOrders: "Purchase Orders",
  processingBatch: "Processing Batch",
  processedCoffeeOutRequired: "Processed Coffee Out is required",
  lotNo: "Lot No",
  addNewS: "Add New",
  viewAll: "View All",
  parchmentOut: "Parchment Out",
  processingDone: "Processing Done",
  farmerLotID: "Farmer & Lot ID",
  weight: "Weight",
  plantationSettings: "Plantation Settings",
  PlantationsEachFarmerCanCreate: "No. of Plantations Each Farmer Can Create",
  manageAdditionalPlantationRequests: "Manage Additional Plantation Requests",
  autoApprove: "Auto Approve",
  adminApprovalRequired: "Admin Approval Required",
  close: "Close",
  new_user: "New User",
  KGAcre: "KG/Acre",

  // Sept 29, 2030
  honey: "Honey",
  naturalDry: "Natural (Dry)",
  wine: "Wine",
  SemiWashed: "Semi-Washed",
  fullWashed: "Full-Washed",
  startDateRequired: "Start Date is required",
  endDateRequired: "End Date is required",
  assigned: "Assigned",
  activated: "Activated",
  unassigned: "Unassigned",
  deleteTopic: "Delete Topic",
  sureToDeleteTopic: "Are you sure you want to delete technical issues topic?",
  publishSurvey: "Publish Survey",
  endSurvey: "End Survey",
  copy: "Copy",
  pending: "Pending",

  // Dashboad Report Translation
  parchmentId: "Parchment ID",
  "Farmer Name": "Farmer Name",
  "Goals Achieved": "Goals Achieved",
  "Goals Failed": "Goals Failed",
  "Success Rate": "Success Rate",
  "Farm Size": "Farm Size",
  "Small Farmer": "Small Farmer",
  "Medium Farmer": "Medium Farmer",
  "Large Farmer": "Large Farmer",

  "Equipment Name": "Equipment Name",
  Farmer: "Farmer",
  Counts: "Counts",

  "Pest Name": "Pest Name",
  "Total Area": "Total Area",
  Region: "Region",
  Crop: "Crop",

  "Crop Name": "Crop Name",
  Farmers: "Farmers",
  Farms: "Farms",
  Planted: "Planted",
  "Planted Area": "Planted Area",
  Harvested: "Harvested",
  "Yield/acre": "Yield/acre",
  "Region Name": "Region Name",

  "Avg. Land/Acre": "Avg. Land/Acre",
  Crops: "Crops",
  "Yield/area": "Yield/area",
  "Avg. land/Acre": "Avg. land/Acre",

  "Farm Name": "Farm Name",
  Zones: "Zones",
  Area: "Area",

  "Goals Achieved Report": "Goals Achieved Report",
  "Farms Report": "Farms Report",
  "Pest Report": "Pest Report",
  "Equipment Report": "Equipment Report",
  "Crops Report": "Crops Report",
  "Farmers Report": "Farmers Report",
  "Regional Report": "Regional Report",
  fermentationCode: "Fermentation Code",

  months: "Months",
  open:"Open",
  closed:"Closed",
  moreInfoRequired: "More Information Required",
  fieldRequired: 'This field is required.',
  valueMustBeGreaterThanZero: 'Value must be greater than zero.',
  valueExceedsLimit: 'Expiry time cannot exceed 12 months as per EUDR regulations.',
  valueMustBeInteger: 'Value must be an integer.',
  viewAssessmentDetails:"View Assessment Details",
  viewDeforestationDetails:"View Deforestation Details",
  listOfShipments:"List of Shipments",
  viewShipment:"View Shipment",
  shipmentCratedSuccess:"Shipment has been created successfully.",
  pleaseSelectAtLeastOneDueDeligenceReport:"Please select at least one due deligence report",
  confirmation: "Confirmation",


  "Day/s": "Day/s",
  "Month/s": "Month/s",
  "Year/s": "Year/s",
  "Hour/s": "Hour/s",
  "Minute/s": "Minute/s",
  "Second/s": "Second/s",
  "Week/s": "Week/s",
  show: "Show",


  noUploadToBlockchain: "No Upload to Blockchain",
  noDataForBlockchain: "Since there were no deforestation reports generated for the production places, there was no data to write to blockchain. If this was unexpected, please ensure that the reports for the farms were generated properly in the previous steps.",
  pleaseAgreeToDeclaration: "Please agree to the declaration statement to conclude.",
  importProductionPlaceTT: "Allows users to import production place data using file upload or download options.",
  defaultCircularGeofence: "Farms without a geofence or without information about their size will be assigned a default circular geofence of 4 hectares. If the average farm size is smaller than 4 hectares, please change the default size by clicking the 'Edit' button below.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "According to EUDR, farms with less than 4 hectares do not require a polygon.",
  uploadOneDeforestationAssessmentForAllFarms: "UPLOAD ONE DEFORESTATION ASSESSMENT FOR ALL FARMS",
  uploadAssessment: "Upload Assessment",


  "timeAgo": {
      "minute": "a minute ago",
      "minutes": "{count} minutes ago",
      "hour": "an hour ago",
      "hours": "{count} hours ago",
      "day": "a day ago",
      "days": "{count} days ago",
      "month": "a month ago",
      "months": "{count} months ago",
      "year": "a year ago",
      "years": "{count} years ago"
    },

    tickets: {
      actions: {
        create: "Create Ticket",
        delete: "Delete Ticket",
        edit: "Edit Ticket",
      },
      areaOfRequest: "Area of Request",
      assignee: "Assignee",
      deleteTicket: {
        confirmation: "Are you sure you want to delete {0} ticket?",
      },
      dueDate: "Due Date",
      filters: {
        ticketFor: "Ticket For",
      },
      form: {
        ticketType: {
          admin: "Create Ticket for Dimitra Admin",
          user: "Create Ticket for App User",
        },
      },
      markAsRead: "Mark as read",
      messages: {
        created: {
          success: "Ticket created successfully",
        },
        deleted: {
          success: "Ticket deleted successfully",
        },
      },
      noData: "No Tickets Found!",
      noDataHelpText: `You don't have any tickets assigned to{0}you yet. Click on "Create Ticket" button{1}on the top of this screen to get started.`,
      pickerInMenu: "Picker in menu",
      priority: {
        high: "High",
        label: "Priority",
        medium: "Medium",
      },
      reply: "Reply",
      requestedDateTime: "Requested Date and Time",
      requestorDetails: "Requestor Details",
      requestorEmail: "Requestor Email",
      subject: "subject",
      ticketsForItems: {
        all: "All",
        dimitraAdmin: "Dimitra Admin",
        multipleUsers: "Multiple Users",
        singleUser: "Single User",
      },
      title: "Tickets",
      
      userDetails: "User Details",
      noUserDetails: "No user details found.",
    },

    faqSection: {
      createFaq: "CREATE FAQ",
      createTopic: "Create Topic",
      selectTopic: "Select Topic",
      faqQuestion: "FAQ Question",
      faqAnswer: "FAQ Answer",
      uploadImgVid: "UploAd Image/Video",
      disInFaq: "Display in FAQ section",
      editFaq: "Edit FAQ",
      topicName: "Topic Name",
      parentTopic: "Parent Topic",
      editTopic: "Edit Topic",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",

      troubleshootingGuide: "Troubleshooting Guide",
      forDetailedTroubleshootingStepsAndSolutions: "For detailed troubleshooting steps and solutions, please refer to our official guide.",
      openTroubleshootingGuide: "Open Troubleshooting Guide",
    },


  confirmDialog: {
    assessmentBuilder: {
      delete: {
        title: "Delete Assessment",
        message: "Are you sure you want to delete Assessment?",
        confirmBtn: "Confirm?",
      },
    },
    dueDiligenceReport: {
      delete: {
        title: "Delete EUDR Due Diligence Report",
        message: "Are you sure you want to delete EUDR Due Diligence Report?",
        confirmBtn: "Confirm",
      },
    },
    farm: {
      delete: {
        title: "Delete Farm",
        message: "Are you sure you want to delete Farm?",
        confirmBtn: "Confirm",
      },
    },
    status: {
      delete: {
        title: "Delete Deforestation Status",
        message: "Are you sure you want to delete deforestation status?",
        confirmBtn: "Confirm",
      },
    },
  },
  seeDetails: "See Details",
  countries: "Countries",
  userId: "User ID",

  tutorials: {
    title: "Tutorials & Guides",
    noTutorials: "No Tutorials",
    addTutorialPrompt: "Please add a tutorial or guide first.",
    videoNotAvailable: "Video not available in your preferred language.",
    watchVideo: "Watch Video",
    viewTutorial: "View Tutorial",
    loading: "Loading tutorials...",
    // Admin management
    manageTutorials: "Manage Tutorials",
    createTutorial: "Create Tutorial",
    editTutorial: "Edit Tutorial",
    deleteTutorial: "Delete Tutorial",
    deleteConfirmation: "Are you sure you want to delete the tutorial '{title}'?",
    createSuccess: "Tutorial created successfully",
    updateSuccess: "Tutorial updated successfully",
    deleteSuccess: "Tutorial deleted successfully",
    createError: "Error creating tutorial",
    updateError: "Error updating tutorial",
    deleteError: "Error deleting tutorial",
    saveError: "Error saving tutorial",
    loadError: "Error loading tutorials",
    createFirstTutorial: "Create your first tutorial to get started",
    // Form fields
    description: "Description",
    url: "URL",
    urlType: "Content Type",
    displayOrder: "Display Order",
    organization: "Organization",
    organizationHint: "Select 'Global' for tutorials available to all organizations, or choose a specific organization",
    userType: "User Type",
    userTypeHint: "Select which type of users can see this tutorial",
    isActive: "Is Active",
    status: "Status",
    actions: "Actions",
    // File upload fields
    uploadFile: "Upload File",
    selectFile: "Select File",
    dragDropFiles: "Drag and drop files here, or click to select",
    fileUploaded: "File uploaded successfully",
    fileUploadError: "Error uploading file",
    fileSizeLimit: "File size must be less than 10MB",
    supportedFormats: "Supported formats: PDF, PNG, JPG, JPEG, GIF",
    removeFile: "Remove File",
    downloadFile: "Download File",
    viewFile: "View File",
    // Filters
    filterByOrganization: "Filter by Organization",
    filterByType: "Filter by Type",
    filterByStatus: "Filter by Status",
    // Status options
    active: "Active",
    inactive: "Inactive",
    global: "Global",
    // User types
    appUsers: "App Users",
    adminUsers: "Admin Users",
    // Content types
    video: "Video",
    pdf: "PDF",
    document: "Document",
    image: "Image",
    // Validation messages
    titleRequired: "Title is required",
    titleMinLength: "Title must be at least 3 characters",
    urlRequired: "URL is required for external links",
    urlInvalid: "Please enter a valid URL",
    urlTypeRequired: "Content type is required",
    fileRequired: "File is required for file-based tutorials",
    urlOrFileRequired: "Either URL or file must be provided",
    // Search functionality
    searchOrganizations: "Search organizations...",
    noOrganizationsFound: "No organizations found",
    searchTutorials: "Search tutorials...",
    selectOrganization: "Select organization...",
    excludeGlobalForOrg: "Exclude global tutorials for selected organization",
    exclusionUpdateSuccess: "Organization tutorial setting updated",
    exclusionUpdateError: "Failed to update tutorial setting",
    exclusionStatusLoadError: "Failed to load organization tutorial setting",
  },

  helpDesk: "Help Desk",
  societies: "Societies",
  selectSocieties: "Select Societies",

  generateSecretKey: "Generate Secret Key",
  secretKey: "Secret Key",
  secretKeyCopied: "Secret key copied to clipboard",
  copied: "Copied",
  copySecretKeyHint: "Click the copy icon to copy the secret key",
}